import { render, staticRenderFns } from "./FePartCategoriesForm.vue?vue&type=template&id=a53c8d5a"
import script from "./FePartCategoriesForm.vue?vue&type=script&lang=js"
export * from "./FePartCategoriesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports